<template>
  <div id="invest-modal">
    <div class="bg-light sticky-top w-100">
      <b-button
        variant="light"
        @click="$emit('closePanel', { closedBy: 'bg' })"
      >
        <close-icon />
      </b-button>
      <div class="wrap py-3 d-inline-block">
        <h6 class="mb-0">Checkout</h6>
      </div>
    </div>
    <div
      class="thumb bg-dark shadow-xl bg-cover text-white position-relative"
      style="height:130px;"
      :style="{
        backgroundImage:
          ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url(` +
          product.image +
          `)`,
      }"
    >
      <div class="wrap position-absolute bottom-0 p-4">
        <component :is="`crowd-funding-icon`" :size="40"></component>
        <h6 class="mb-0">{{ product.name }}</h6>
      </div>
    </div>
    <b-container>
      <b-col cols="12">
        <div class="">
          <div class="mt-3">
            <p class="mb-0">{{ product.name }}</p>
            <small>
              {{ product.description }}
            </small>
          </div>
          <div class="mt-4 d-flex justify-content-between">
            <div class="">
              <small> <b> Quantity</b> <br /> </small>
              <div class="mt-2">
                <span
                  @click="decrementQty()"
                  class="badge badge-primary mr-3 pointer text-light"
                >
                  -
                </span>
                <b>{{ cart.quantity }}</b>
                <span
                  @click="cart.quantity++"
                  class="badge badge-primary  ml-3  pointer text-light"
                >
                  +
                </span>
              </div>
            </div>
            <div class="">
              <small>Total</small>
              <h4 class="mb-0 mt-2">{{ formatMoney(calcTotal) }}</h4>
            </div>
          </div>
          <!-- <div class="mt-4 d-flex justify-content-between align-items-center">
                    <b-form-checkbox size="lg" checked="true"><label class="mt-2" for="">Ja</label></b-form-checkbox>

                    <b-form-select v-model="selected" :options="options" class="mb-3 option-drop">
                        <template #first>
                            <b-form-select-option :value="null" disabled>-- select an option --</b-form-select-option>
                        </template>
                    </b-form-select>
                </div> -->
        </div>

        <transition name="fade" mode="out-in">
          <b-button
            class="w-100 mt-5 bg-primary text-light "
            @click="addItemToCart()"
            v-if="!addtocart"
            variant="outline-primaey"
            >ADD TO CART <i class="fas fa-shopping-cart float-right"></i>
          </b-button>

          <div class="" v-else>
            <b-button
              class="w-100 mt-5 bg-primary text-light "
              @click="$emit('closePanel', { purchase: true, closedBy: 'bg' })"
              variant="outline-primaey"
              >CHECKOUT <i class="fas fa-shopping-cart float-right"></i>
            </b-button>
            <b-button
              class="w-100 mt-2 bg-transparent text-primary  border-primary"
              @click="$emit('closePanel', { closedBy: 'bg' })"
              >CONTINUE SHOPPING
            </b-button>
          </div>
        </transition>
      </b-col>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import paystack from "vue-paystack";
import { mapState } from "vuex";
import { formatMoney } from "@/utils/helpers";
import { TransactionService } from "@/services";
import nigerianBanks from "@/utils/nigerianBanks";

import { validateRequired, checkFormErrors } from "@/utils/validators";

export default {
  name: "invest-modal",
  props: {
    product: null,
  },
  mounted() {
    this.form.packageid = this.product.id;
    this.cart.amount = this.product.amountperplot;
  },
  data() {
    return {
      cart: {
        quantity: 1,
        amount: null,
      },
      form: {
        units: 0,
        reference: null,
        packageid: 0,
        paymentproof: null,
        bankcode: null,
        farmService: 0,
        farmPackage: "",
        requesttype: "farm-sale",
      },
      addtocart: false,
      farmPrice: 0,
      ServiceCost: 0,
      farmPackage: [
        { text: "Rent a farm", amount: 35000 },
        { text: "Own a farm", amount: 50000 },
      ],
      selected: null,
      //   options2: [
      //     { value: 'A', text: 'Option A (from options prop)' },
      //     { value: 'B', text: 'Option B (from options prop)' }
      //   ],
      options: ["PAYG", "Outright"],

      error: false,
      loading: false,
      submitting: false,
      submittingPaystack: false,
      amountPaystack: 0,
      nigerianBanks: nigerianBanks,
      paymentType: null,
      paystackKey: process.env.VUE_APP_PAYSTACK_KEY,
      paymentOptions: [
        { text: "Card", value: "card" },
        { text: "Bank Transfer/ Deposit", value: "bank" },
      ],
      formErrors: {},
    };
  },
  components: {
    paystack,
  },
  computed: {
    ...mapState(["userObj"]),
    ...mapGetters(["CartItems"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    },

    calcTotal() {
      return this.cart.quantity * Number(this.product.price);
    },

    roi() {
      if (!this.product) return formatMoney(0);
      const averagereturns = (this.product.minroi + this.product.maxroi) / 2;
      return formatMoney(
        this.ServiceCost + (this.ServiceCost * averagereturns) / 100
      );
    },
    state() {
      return this.farmPackage !== "" ? true : false;
    },
    validFeedback() {
      return this.state === true ? "Thank you" : "";
    },
    invalidFeedback() {
      if (this.farmPackage !== "") {
        return "";
      } else {
        return "Please select farm package";
      }
    },
  },

  methods: {
    formatMoney,

    addItemToCart() {
      this.addtocart = true;
      let message = "Item added to the cart";

      this.$store.dispatch("toast", {
        message,
        variant: "success",
      });

      let cartItem = {
        product: this.product,
        edibleid: this.product.id,
        quantity: this.cart.quantity,
        amount: Number(this.product.price * this.cart.quantity),
      };

      this.$store.dispatch("addItemToCart", cartItem);
    },

    generateCost() {
      this.farmPackage.find((item) => {
        if (item.text.toLowerCase() == this.form.farmPackage.toLowerCase()) {
          this.farmPrice = item.amount * this.form.units;
          this.ServiceCost = this.product.amountperplot * this.form.units;
          this.amountPaystack = this.farmPrice + this.ServiceCost;
        }
      });
    },

    decrementQty() {
      if (this.cart.quantity > 1) {
        this.cart.quantity--;
      }
    },

    openPaystack(event) {
      event.preventDefault();
      if (this.form.units < 1) {
        this.formErrors = { units: "Please enter number of units to purchase" };
        this.error = true;
        return;
      }
      if (!this.form.packageid) {
        this.formErrors = { packageid: "Please select a package" };
        this.error = true;
        return;
      }

      // console.log('Here');
      const btn = document.querySelector(".payButton");
      btn.click();
    },
    async paystackCallback(response) {
      const { reference } = response;
      // console.log(reference);

      this.submittingPaystack = true;
      try {
        const { message } = await TransactionService.verify({
          reference,
          id: this.form.packageid,
          requesttype: this.form.requesttype,
          units: this.form.units,
        });

        this.$store.dispatch("toast", {
          message,
        });

        this.$emit("closePanel", true);

        /**setTimeout(() => {
          location.reload();
        }, 1000 * 1.5);**/
      } catch (err) {
        this.submittingPaystack = false;
      }
    },

    paystackClose() {},

    async submit(event) {
      //console.log("HEREE");
      //console.log(this.form.reference);
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        // this.processUpload();
        const { message } = await TransactionService.manualPayment({
          packageid: this.form.packageid,
          reference: this.form.reference,
          paymentproof: this.form.paymentproof,
          bankcode: this.form.bankcode,
          requesttype: this.form.requesttype,
        });
        //console.log("MESSAGE");

        this.$store.dispatch("toast", {
          message,
        });
        this.$emit("closePanel", true);
      } catch (err) {
        this.error = true;
        this.formErrors = err;
      } finally {
        this.submitting = false;
      }
    },
    validateForm() {
      const { reference, packageid, paymentproof, bankcode } = this.form;
      let { errors, valid } = validateRequired({
        reference,
        packageid,
        paymentproof,
        bankcode,
      });

      if (
        !errors.paymentproof &&
        paymentproof &&
        !["image/jpeg", "image/jpg", "image/png"].includes(
          this.form.paymentproof.type
        )
      ) {
        errors.paymentproof = "Only picture is allowed i.e jpeg, jpg, png";
        valid = false;
      }

      if (
        !errors.paymentproof &&
        paymentproof &&
        this.form.paymentproof.size > 20 * 1024 * 1024
      ) {
        errors.paymentproof = "File size is too large (20MB Maximum)";
        valid = false;
      }

      if (this.form.packageid == 0) {
        errors.packageid = "You need to select a package";
        valid = false;
      }

      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    validateNoDecimals(e) {
      const key = e.key;

      // If is '.' key, stop it
      if (key === ".") return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === "e") return e.preventDefault();
    },
    validateNoDecimalsOnPaste() {
      this.form.units = this.form.units.replace(/[^0-9]+/g, "");
      if (this.form.units > 0)
        this.amountPaystack = this.form.units * this.product.amountperplot;
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    getBG(slug) {
      if (slug == "crowd-funding") {
        return "https://images.pexels.com/photos/681335/pexels-photo-681335.jpeg?auto=compress&cs=tinysrgb&h=650&w=940";
      } else {
        return "https://images.pexels.com/photos/87223/pexels-photo-87223.jpeg?auto=compress&cs=tinysrgb&h=650&w=940";
      }
    },
  },
};
</script>

<style scoped>
.pay-btn {
  margin-top: -35px;
}

.option-drop {
  padding: 2px 10px !important ;
  height: 45px;
  width: 250px;
}
.moneyTag {
  padding: 15px 10px;
  columns: #000;
  background: #ebebeb;
  font-size: 17px !important;
}

.pointer {
  cursor: pointer;
  font-size: 25px;
  padding: 1px 10px 5px;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.4s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
